import React, { FC } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { ToggleBlock } from "../../../components/ToggleBlock/ToggleBlock";
import { getPrintWithScale } from "../../../ducks/print/selectors";
import { toggleScaleSetting } from "../../../ducks/print/print";
import { useActionWithArgs } from "../../../hooks/useAction";

export const ScaleSetting: FC = () => {
  const { t } = useTranslation("print");
  const [withScale, toggle] = [useSelector(getPrintWithScale), useActionWithArgs(toggleScaleSetting)];

  return <ToggleBlock label={t("scale")} checked={withScale} onChange={toggle} />;
};
